import React, { useEffect, useState } from "react";
import "./Home.css"; // contains dark/light theme styles

const Team = () => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  const API_URL = "https://adnyatech.com:8082/adnya/team_member/view_y";

useEffect(() => {
  setLoading(true);
  fetch(API_URL, {
    method: "GET",
    credentials: "include", // ← send session cookies
  })
    .then((res) => {
      if (!res.ok) throw new Error("Network response was not ok");
      return res.json();
    })
    .then((data) => {
      setTeamMembers(data);
      setLoading(false);
    })
    .catch((err) => {
      console.error("Error fetching team data:", err);
      setLoading(false);
    });
}, []);


  return (
    <div className="team-wrapper">
      <div className="team-container">
        <h1 className="team-heading">Our Team</h1>
        <p className="team-intro">
          Adnya Technologies is led by experienced developers and supported by a trusted network of skilled
          freelancers and collaborators. We work together to bring your ideas to life.
        </p>

        {loading ? (
          <p className="loading-text">Loading team members...</p>
        ) : (
          <div className="team-grid">
            {teamMembers.map((member) => (
              <div key={member.id} className="team-card">
                <img
                  src={`https://adnyatech.com:8082${member.photoUrl}`}
                  alt={member.name}
                  className="team-photo"
                />
                <div className="team-info">
                  <h3 className="team-name">{member.name}</h3>
                  <p className="team-role">{member.role}</p>
                  <p className="team-experience">Experience: {member.experience}</p>
                  <p className="team-bio">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Team;
